import { Component } from '@angular/core'
import {
  MbMyaccountAddressbookBaseComponent
} from '../mb-myaccount-addressbook-base/mb-myaccount-addressbook-base.component'
import {
  MbMyaccountAddressbookConnector
} from '../../../connectors/mb-myaccount-addressbook.connector'
import { MbCheckoutRegions } from '../../../../models'

@Component({
  selector: 'mb-myaccount-addressbook-us',
  templateUrl: './mb-myaccount-addressbook-us.component.html',
  styleUrls: ['../mb-myaccount-addressbook-base/mb-myaccount-addressbook-base.component.scss']
})
export class MbMyaccountAddressbookUsComponent extends MbMyaccountAddressbookBaseComponent {

  checkoutRegion = MbCheckoutRegions.US

  constructor (protected mbMyaccountAddressbookConnector: MbMyaccountAddressbookConnector) {
    super(mbMyaccountAddressbookConnector)
  }
}
